export default {
  SEND_EMAIL_NOTIFICATION: {
    HELP: 'Because the signing is today, the notary will also receive a notification via SMS',
    CHECKBOX: 'Send comment notification via email',
    PARTICIPANTS_CHECKBOX: 'Notify participants'
  },
  SUBMIT: {
    SEND: 'Send',
    CREATE_NOTE: 'Add internal note',
    CREATE_NOTE_EXPLANATION:
      'This note will only be available to members of your company. To share with others, add a recipient.'
  },
  CREATE: {
    ERROR: 'Your comment could not be sent. Please try again.'
  },
  AI_SUGGESTIONS: {
    LOCK_HELP: `Keep a draft you're working on with AI suggestions by clicking "Use or edit" and then Command + Z.`,
    NO_RESPONSE_NEEDED: 'No response needed',
    DECIDE_ERROR: 'Something went wrong. Please try again.'
  }
}
